import { render, staticRenderFns } from "./flzgcyz.vue?vue&type=template&id=1dc7e0c6&scoped=true"
import script from "./flzgcyz.vue?vue&type=script&lang=js"
export * from "./flzgcyz.vue?vue&type=script&lang=js"
import style0 from "./flzgcyz.vue?vue&type=style&index=0&id=1dc7e0c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7e0c6",
  null
  
)

export default component.exports